export const DOG_TRICKS = [
  { id: 'zoomies', label: 'zoomies' },
  { id: 'roll-around', label: 'roll around' },
  { id: 'beg', label: 'beg' },
  { id: 'shake-a-paw', label: 'shake a paw' },
  { id: 'spin', label: 'spin' },
  { id: 'lick-a-lifted-leg', label: 'lick a lifted leg' },
  { id: 'play-bow', label: 'play bow' },
  { id: 'dig', label: 'dig' },
  { id: 'sniff', label: 'sniff' },
  { id: 'catch', label: 'catch' },
  { id: 'shake-off', label: 'shake off' },
];

export const PERSON_ACTIVITY_POSES = [
  { id: 'building-fire', label: 'building fire' },
  { id: 'pointing', label: 'pointing' },
  { id: 'chopping-wood', label: 'chopping wood' },
  { id: 'sitting', label: 'sitting' },
  { id: 'laying-down', label: 'laying down' },
  { id: 'cooking', label: 'cooking' },
  { id: 'waving', label: 'waving' },
  { id: 'hugging', label: 'hugging' },
  { id: 'talking', label: 'talking' },
  { id: 'eating', label: 'eating' },
  { id: 'looking-back', label: 'looking back' },
  { id: 'hiding', label: 'hiding' },
  { id: 'reaching', label: 'reaching' },
  { id: 'comforting', label: 'comforting' },
];

export const HEAD_POSE = { id: 'head', label: 'head' };
export const STANDING_POSE = { id: 'standing', label: 'standing' };
export const TOP_DOWN_POSE = { id: 'top-down', label: 'top down' };
export const ROAD_POSE = { id: 'on-the-road', label: 'on the road' };
export const ROAD_TOP_DOWN_POSE = { id: 'on-the-road-top-down', label: 'on the road top down' };
export const FLIGHT_POSE = { id: 'in-flight', label: 'in flight' };
export const FLIGHT_TOP_DOWN_POSE = { id: 'in-flight-top-down', label: 'in flight top down' };
export const LIFTOFF_POSE = { id: 'liftoff', label: 'liftoff' };

export function vanShowsFlight(character) {
  const animation = character?.meta?.animation;
  if (animation && typeof animation === 'object') {
    return Boolean(String(animation.flight || '').trim());
  }
  const year = Number(character?.meta?.year);
  if (year === 2068 || year === 2065) return true;
  return /2068|2065/.test(String(character?.id || ''));
}
